// extracted by mini-css-extract-plugin
export default {"grain":"Grain_grain__HB0K6"};